import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import teamStyle from "assets/jss/material-kit-react/views/landingPageSections/teamStyle.jsx";

// import sarjiman from "assets/img/faces/sarjiman.png";
// import mohamad from "assets/img/faces/mohamad.png";
import sarjiman from "assets/img/faces/ajihmm.png";
import maria from "assets/img/faces/maria.png";
import herawan from "assets/img/faces/herawan.png";
import anton from "assets/img/faces/anton.png";
import anisa from "assets/img/faces/anisa.png";
import ahmad from "assets/img/faces/ahmad.png";

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';

class TeamSection extends React.Component {
  state = {
    open: false,
    expanded: null,
  };
  handleClick = () => {
    this.setState(state => ({ open: !state.open }));
  };

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };
  render() {
    const { expanded } = this.state;
    const { classes } = this.props;
    // const imageClasses = classNames(
    //   classes.imgRaised,
    //   classes.imgRoundedCircle,
    //   classes.imgFluid
    // );
    return (
      <div className={classes.section}>
        <h2 className={classes.title} style={{ color: "#4BB64B" }}>OUR PEOPLE</h2>
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div className={classes.container}>
            <br />
            <ExpansionPanel expanded={expanded === 'panel1'} onChange={this.handleChange('panel1')}>
              <ExpansionPanelSummary >
                <Typography>
                  <h3 style={{ textAlign: "left" }}>
                    <img src={sarjiman} alt="Aji" style={{ width: 140, height: 170, marginRight: 15, float: 'left' }} />
                    <b>Aji Respati</b>
                  </h3>
                  <h4 style={{ textAlign: "left" }}> <b>Founder / Senior Consultant of Information Technology</b></h4>
                  <h4 style={{ textAlign: "left" }}>
                    Aji Respati has a long string of success story in multinational Information and Communication technology across the globe.
                    He starts as a system engineer, following by solution architect, presales activities, up to top strategic
                    management decision on technology implementations. Therefore, he definitely understand very well various aspect
                    of breakthrough technology and related risks to be calculated and managed. As the current business environment
                    is all about technology and having a calculated risks defines the successful and the remaining,
                    strong command of technical person in a company is a key. Your business also will get benefit from technical
                    insight through series of successful transformations that Sandton Consulting will bring to your table.
                  </h4>
                </Typography>
              </ExpansionPanelSummary>
            </ExpansionPanel>
            <ExpansionPanel expanded={expanded === 'panel2'} onChange={this.handleChange('panel2')}>
              <ExpansionPanelSummary >
                <Typography>
                  <h3 style={{ textAlign: "left" }}>
                    <img src={herawan} alt="Herawan" style={{ width: 140, height: 170, marginRight: 15, float: 'left' }} />
                    <b>Herawan Saputro</b>
                  </h3>
                  <h4 style={{ textAlign: "left" }}> <b>Co-Founder / Senior Consultant of ISO Certification</b></h4>
                  <h4 style={{ textAlign: "left" }}>
                    Food safety is his special area of expertise that set standards for many companies in order to achieve sustainable yet profitable business at once. Putro begins with food and beverage industry in his career and evolve into lead consultant and auditor of standard practices such as ISO 9001, ISO 14001, and HACCP for many companies.
                  </h4>
                  <h4 style={{ textAlign: "left" }}>
                    His approach in order to put company practices into standard is by doing thorough examination of what existing values the company owns and then combine it with the commonly accepted standards. Therefore, the solution fits to almost any kind of business and entities of any size.  With an outstanding communication skill, Putro always bring fresh awareness on standardization to his training audiences as well as glued it together into new accomplishment.
                  </h4>
                </Typography>
              </ExpansionPanelSummary>
            </ExpansionPanel>
            <ExpansionPanel expanded={expanded === 'panel3'} onChange={this.handleChange('panel3')}>
              <ExpansionPanelSummary >
                <Typography>
                  <h3 style={{ textAlign: "left" }}>
                    <img src={anton} alt="Anton" style={{ width: 150, height: 170, marginRight: 15, float: 'left' }} />
                    <b>YB Anton Dewantoro</b>
                  </h3>
                  <h4 style={{ textAlign: "left" }}> <b>Co-Founder / Director of Operations</b></h4>
                  <h4 style={{ textAlign: "left" }}>
                    Anton is a technology slash business developer with wide range of experiences in technical implementation, project management, talent management, training, and strategic marketing.
                  </h4>
                  <h4 style={{ textAlign: "left" }}>
                    With a number of years working with entities both local and multinational he helps Sandton Consulting to grow the culture of successful business practices that in turns will resonates to the projects that the company handles.
                  </h4>
                </Typography>
              </ExpansionPanelSummary>
            </ExpansionPanel>
            <ExpansionPanel expanded={expanded === 'panel4'} onChange={this.handleChange('panel4')}>
              <ExpansionPanelSummary >
                <Typography>
                  <h3 style={{ textAlign: "left" }}>
                    <img src={ahmad} alt="Ahmad" style={{ width: 140, height: 170, marginRight: 15, float: 'left' }} />
                    <b>Ahmad Zahrul Mustafiddin</b>
                  </h3>
                  <h4 style={{ textAlign: "left" }}>
                    <b>Partner / Project Management Consultant Expert</b>
                  </h4>
                  <h4 style={{ textAlign: "left" }}>
                    Ahmad Zahrul has more than 15 years of experience in Program & Project Management in Telco & IT Industry for both Government & Multi National Enterprise. Also holds International Certification such PMP, RMP, C&SI CPM, ITILF.
                  </h4>
                  <h4 style={{ textAlign: "left" }}>
                    He leads numbers of successful programs in project management mostly covering Telecommunications, Banking and Information Technology in extent.
                  </h4>
                </Typography>
              </ExpansionPanelSummary>
            </ExpansionPanel>
            {/* <ExpansionPanel expanded={expanded === 'panel6'} onChange={this.handleChange('panel6')}>
              <ExpansionPanelSummary >
                <Typography>
                  <h3 style={{ textAlign: "left" }}>
                    <img src={mohamad} alt="Mochammad" style={{ width: 140, height: 170, marginRight: 15, float: 'left' }} />
                    <b>Mochammad Arfi Maulana</b>
                  </h3>
                  <h4 style={{ textAlign: "left" }}>
                    <b>Partner / Senior Consultant of ISO Certification</b>
                  </h4>
                  <h4 style={{ textAlign: "left" }}>
                    Arfi is a specialist on Quality Management System and Information Management System with real world experiences that enables him to deliver a distinguis result for your company. He has an adaptable approach into many circumstances so that the solution he brings is tailor made and suits well to your business practices and company culture.
                  </h4>
                  <h4 style={{ textAlign: "left" }}>
                    He has expertise and real world experience in quality management systems, environmental management systems, safety management systems, as well as chemical process engineering. All the above system management already being delivered to a number of organizations nationwide in any scale.
                  </h4>
                </Typography>
              </ExpansionPanelSummary>
            </ExpansionPanel> */}
            <ExpansionPanel expanded={expanded === 'panel5'} onChange={this.handleChange('panel5')}>
              <ExpansionPanelSummary >
                <Typography>
                  <h3 style={{ textAlign: "left" }}>
                    <img src={maria} alt="Maria" style={{ width: 140, height: 170, marginRight: 15, float: 'left' }} />
                    <b>Maria Flora Rosalyn</b>
                  </h3>
                  <h4 style={{ textAlign: "left" }}>
                    <b>Finance / Tranformation Manager</b>
                  </h4>
                  <h4 style={{ textAlign: "left" }}>
                    With years of experience in extensive project, Flora helps a number of companies through technological transformation processes which goal is to achieve better resource efficiency and improving the outcome at once.
                  </h4>
                  <h4 style={{ textAlign: "left" }}>
                    To communicate well with all stakeholders in the business is also another traits that she possess in order to ensure that a business will be successful not only financially but also as a whole entity.
                  </h4>
                </Typography>
              </ExpansionPanelSummary>
            </ExpansionPanel>
            <ExpansionPanel expanded={expanded === 'panel7'} onChange={this.handleChange('panel7')}>
              <ExpansionPanelSummary >
                <Typography>
                  <h3 style={{ textAlign: "left" }}>
                    <img src={anisa} alt="Annisa" style={{ width: 140, height: 170, marginRight: 15, float: 'left' }} />
                    <b>Annisa Trias Nurdiansari</b>
                  </h3>
                  <h4 style={{ textAlign: "left" }}>
                    <b>Business Development Manager</b>
                  </h4>
                  <h4 style={{ textAlign: "left" }}>
                    Her background in chemical instrumentation research helps her to find the best solution for industries who look into bespoke quality management standards. Therefore, Annisa is not only see the business development in Sandton Consulting as marketing activity but more into shaping a tool for your organization to tackle many challenges in disruptive business environment nowadays.
                  </h4>
                  <h4 style={{ textAlign: "left" }}>
                    She will definitely happy to sit with your team to design a training or consulting program that bring answers to your current needs. A preliminary assesment can be performed in advance so that you only get the best fit solutions to your problems.
                  </h4>
                </Typography>
              </ExpansionPanelSummary>
            </ExpansionPanel>
            <br />
          </div>
        </div>
        {/* <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={4}>
              <Card plain>
                <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                  <img src={team1} alt="..." className={imageClasses} />
                </GridItem>
                <h4 className={classes.cardTitle}>
                  ANTON DEWANTORO
                  <br />
                  <small className={classes.smallTitle}>Model</small>
                </h4>
                <CardBody>
                  <p className={classes.description}>
                    You can write here details about one of your team members.
                    You can give more details about what they do. Feel free to
                    add some <a href="#pablo">links</a> for people to be able to
                    follow them outside the site.
                  </p>
                </CardBody>
                <CardFooter className={classes.justifyCenter}>
                  <Button
                    justIcon
                    color="transparent"
                    className={classes.margin5}
                  >
                    <i className={classes.socials + " fab fa-twitter"} />
                  </Button>
                  <Button
                    justIcon
                    color="transparent"
                    className={classes.margin5}
                  >
                    <i className={classes.socials + " fab fa-instagram"} />
                  </Button>
                  <Button
                    justIcon
                    color="transparent"
                    className={classes.margin5}
                  >
                    <i className={classes.socials + " fab fa-facebook"} />
                  </Button>
                </CardFooter>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <Card plain>
                <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                  <img src={team2} alt="..." className={imageClasses} />
                </GridItem>
                <h4 className={classes.cardTitle}>
                  SARJIMAN
                  <br />
                  <small className={classes.smallTitle}>Designer</small>
                </h4>
                <CardBody>
                  <p className={classes.description}>
                    You can write here details about one of your team members.
                    You can give more details about what they do. Feel free to
                    add some <a href="#pablo">links</a> for people to be able to
                    follow them outside the site.
                  </p>
                </CardBody>
                <CardFooter className={classes.justifyCenter}>
                  <Button
                    justIcon
                    color="transparent"
                    className={classes.margin5}
                  >
                    <i className={classes.socials + " fab fa-twitter"} />
                  </Button>
                  <Button
                    justIcon
                    color="transparent"
                    className={classes.margin5}
                  >
                    <i className={classes.socials + " fab fa-linkedin"} />
                  </Button>
                </CardFooter>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <Card plain>
                <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                  <img src={team3} alt="..." className={imageClasses} />
                </GridItem>
                <h4 className={classes.cardTitle}>
                  PUTRO
                  <br />
                  <small className={classes.smallTitle}>Model</small>
                </h4>
                <CardBody>
                  <p className={classes.description}>
                    You can write here details about one of your team members.
                    You can give more details about what they do. Feel free to
                    add some <a href="#pablo">links</a> for people to be able to
                    follow them outside the site.
                  </p>
                </CardBody>
                <CardFooter className={classes.justifyCenter}>
                  <Button
                    justIcon
                    color="transparent"
                    className={classes.margin5}
                  >
                    <i className={classes.socials + " fab fa-twitter"} />
                  </Button>
                  <Button
                    justIcon
                    color="transparent"
                    className={classes.margin5}
                  >
                    <i className={classes.socials + " fab fa-instagram"} />
                  </Button>
                  <Button
                    justIcon
                    color="transparent"
                    className={classes.margin5}
                  >
                    <i className={classes.socials + " fab fa-facebook"} />
                  </Button>
                </CardFooter>
              </Card>
            </GridItem>
          </GridContainer>
        </div> */}
      </div>
    );
  }
}

export default withStyles(teamStyle)(TeamSection);



// WEBPACK FOOTER //
// ./src/views/AboutPage/Sections/TeamSection.jsx